// extracted by mini-css-extract-plugin
export default {"title":"Panel_title__q0P99","message":"Panel_message__B48bH"};